import React, { useState } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchAdnumber, fetchAdvertiser, fetchBannerType } from "../actions";
import { Form, Dropdown } from "semantic-ui-react";

const Search = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const retailers = useSelector((state) => state.retailers);
  let advertisers = useSelector((state) => state.advertisers);
  let retailer = useSelector((state) => state.retailer);

  const [inputValue, setInputValue] = useState("");
  const [selectValue, setSelectValue] = useState("");
  const [bannerTypeValue, setBannerTypeValue] = useState("");

  const handleChange = (e, { name, value }) => setInputValue(value);

  const handleSelectChange = (e, { value }) => {
    setSelectValue(value);
    dispatch(fetchAdvertiser(value));
    setSelectValue("");
    navigate(`/${retailer}/list/1`);
  };

  const handleBannerTypeChange = (e, { value }) => {
    setBannerTypeValue(value);
    dispatch(fetchBannerType(value));
    setBannerTypeValue("");
    navigate(`/${retailer}/list/1`);
  };

  const handleSubmit = () => {
    if (inputValue) {
      dispatch(fetchAdnumber(inputValue));
      setInputValue("");
      navigate(`/${retailer}/list/1`);
    }
  };

  const advertiserOptions = advertisers.map((supplier) => ({
    key: supplier.advertiserId,
    text: supplier.displayName,
    value: supplier.displayName,
  }));

  const currentRetailer = _.find(retailers, (item) => item.name === retailer);
  const creativeTypeOptions = _.uniqBy(
    (currentRetailer?.templates || []).map((template) => ({
      key: template.name,
      text: template.displayName || template.name,
      value: template.name,
    })),
    "value"
  );

  return (
    <Form onSubmit={handleSubmit} className="list-search" size="mini">
      <Form.Group>
        {!user.restrictByAdvertiser && (
          <Form.Field>
            <Dropdown
              placeholder="Search by advertiser"
              search
              selection
              selectOnBlur={false}
              options={advertiserOptions}
              onChange={handleSelectChange}
              value={selectValue}
              className="list-filter-selection"
            />
          </Form.Field>
        )}
        <Form.Field>
          <Dropdown
            placeholder="Filter by creative type"
            search
            selection
            selectOnBlur={false}
            options={creativeTypeOptions}
            onChange={handleBannerTypeChange}
            value={bannerTypeValue}
            className="list-filter-selection"
          />
        </Form.Field>
        <Form.Input
          icon={{ name: 'search', link: true, onClick: handleSubmit }}
          placeholder="Search by Ad Number"
          type="number"
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSubmit();
            }
          }}
          value={inputValue}
        />
      </Form.Group>
    </Form>
  );
};

export default Search;
